// extracted by mini-css-extract-plugin
export var body = "enrollModal-module--body--d6882";
export var card = "enrollModal-module--card--be04f";
export var modal = "enrollModal-module--modal--50c39";
export var title = "enrollModal-module--title--5394b";